<!-- Global navigation loading indicator -->
<div class="route-loading-indicator" *ngIf="isNavigating">
  <div class="progress-bar"></div>
</div>

<router-outlet *ngIf="!isIframe"></router-outlet>